import { OverlayParticleProperties } from "@lib/titan2/dist/game/view/properties/AbstractOverlayProperties";
import * as PIXI from "pixi.js";
import { GameStyle } from "../style/GameStyle";
import { AbstractViewProperties } from "@lib/titan2/dist/game/view/properties/AbstractViewProperties";
import { SpineProperties } from "@lib/titan2/dist/game/control/properties/SpineProperties";
/**
 * FreeSpinsOverlayProperties.ts
 */
export class GameFreeSpinsOverlayProperties extends AbstractViewProperties {
    constructor() {
        super();
        this.setDefaultValues();
    }
    setDefaultValues() {
        this.trailProperties = new SpineProperties("EnergyTrail", GameStyle.MODULE, new PIXI.Point());
        this.particleProperties = [
            new OverlayParticleProperties({ id: `${GameStyle.REEL}_0`, sourceId: `${GameStyle.REEL}_0`, destinationId: GameStyle.REMAINING_FREE_SPINS }),
            new OverlayParticleProperties({ id: `${GameStyle.REEL}_1`, sourceId: `${GameStyle.REEL}_1`, destinationId: GameStyle.REMAINING_FREE_SPINS }),
            new OverlayParticleProperties({ id: `${GameStyle.REEL}_2`, sourceId: `${GameStyle.REEL}_2`, destinationId: GameStyle.REMAINING_FREE_SPINS }),
            new OverlayParticleProperties({ id: `${GameStyle.REEL}_3`, sourceId: `${GameStyle.REEL}_3`, destinationId: GameStyle.REMAINING_FREE_SPINS }),
            new OverlayParticleProperties({ id: `${GameStyle.REEL}_4`, sourceId: `${GameStyle.REEL}_4`, destinationId: GameStyle.REMAINING_FREE_SPINS })
        ];
        this.particleProperties.forEach(prop => prop.sourceOffset = new PIXI.Point(30, 30));
        this.particleProperties.forEach(prop => prop.destinationOffset = new PIXI.Point(0, 50));
    }
}
//# sourceMappingURL=GameFreeSpinsOverlayProperties.js.map